export enum SortType {
  ASC = 'asc',
  DESC = 'desc',
}

export interface ISort {
  column: string;
  type: SortType;
}
